import { useRootLoaderData } from '~/common/utils/useRootLoaderData';

/**
 * Hook to get the session customer from the route loader data.
 * This data is only refreshed when the language changes or a new login is performed.
 */
export function useLoginInfo() {
  const { loginInfo, isSalesOrderSetFilterActive, sessionId } = useRootLoaderData();
  return { loginInfo, isSalesOrderSetFilterActive, sessionId };
}
